import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { createElement as _createElement } from "react";
import { Divider } from 'antd';
export var divider = function divider(item) {
  /** 分割线 */
  if (item.valueType === 'divider') {
    var _item$getFieldProps;

    return /*#__PURE__*/_createElement(Divider, _objectSpread(_objectSpread({}, (_item$getFieldProps = item.getFieldProps) === null || _item$getFieldProps === void 0 ? void 0 : _item$getFieldProps.call(item)), {}, {
      key: item.key
    }));
  }

  return true;
};